const initialState = {
  episode: {
    public_stats: {}
  },
  pages: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_CURRENT_EPISODE_SUCCESS':
      return action.payload;
    case 'POPPIN_ADD':
      return Object.assign({}, state, {
        pages: [
          ...state.pages.slice(0, action.pageIdx),
          Object.assign({}, state.pages[action.pageIdx], {
            tsukkomi_comments: [
              ...state.pages[action.pageIdx].tsukkomi_comments,
              action.poppin
            ]
          }),
          ...state.pages.slice(action.pageIdx+1, state.pages.length)
        ]
      });
    case 'POPPIN_DELETE':
      const pageRemIdx = state.pages.findIndex(page => page.tsukkomi_comments.filter(poppin => poppin.id === action.poppin.parentId).length > 0);
      const pinRemIdx = state.pages[pageRemIdx].tsukkomi_comments.findIndex(poppin => poppin.id === action.poppin.parentId);
      return Object.assign({}, state, {
        pages: [
          ...state.pages.slice(0, pageRemIdx),
          Object.assign({}, state.pages[pageRemIdx], {
            tsukkomi_comments: [
              ...state.pages[pageRemIdx].tsukkomi_comments.slice(0, pinRemIdx),
              ...state.pages[pageRemIdx].tsukkomi_comments.slice(pinRemIdx + 1, state.pages[pageRemIdx].tsukkomi_comments.length),
            ]
          }),
          ...state.pages.slice(pageRemIdx + 1, state.pages.length)
        ]
      });
    case 'POPPIN_DRAGGED_SET':
      return Object.assign({}, state, {
        pages: [
          ...state.pages.slice(0, action.pageIdx),
          Object.assign({}, state.pages[action.pageIdx], {
            tsukkomi_comments: [
              ...state.pages[action.pageIdx].tsukkomi_comments.slice(0, action.pinIdx),
              Object.assign({}, state.pages[action.pageIdx].tsukkomi_comments[action.pinIdx], {
                pos_x: action.posX,
                pos_y: action.posY
              }),
              ...state.pages[action.pageIdx].tsukkomi_comments.slice(action.pinIdx + 1, state.pages[action.pageIdx].tsukkomi_comments.length),
            ]
          }),
          ...state.pages.slice(action.pageIdx+1, state.pages.length)
        ]
      });
    case 'POPPIN_BODY_SET':
      const pageIdx = state.pages.findIndex(page => page.id === action.poppin.page_id);
      const pinIdx = state.pages[pageIdx].tsukkomi_comments.findIndex(poppin => poppin.id === action.poppin.id);
      return {
        ...state,
        pages: [
          ...state.pages.slice(0, pageIdx),
          {
            ...state.pages[pageIdx],
            tsukkomi_comments: [
              ...state.pages[pageIdx].tsukkomi_comments.slice(0, pinIdx),
              action.poppin,
              ...state.pages[pageIdx].tsukkomi_comments.slice(pinIdx + 1, state.pages[pageIdx].tsukkomi_comments.length)
            ]
          },
          ...state.pages.slice(pageIdx + 1, state.pages.length)
        ]
      };
    case 'TOGGLE_LIKE_EPISODE':
      if (state.liked) {
        return {
          ...state,
          liked: false,
          episode: {
            ...state.episode,
            public_stats: {
              ...state.episode.public_stats,
              likes_count: state.episode.public_stats.likes_count - 1
            }
          }
        };

      } else {
        return {
          ...state,
          liked: true,
          episode: {
            ...state.episode,
            public_stats: {
              ...state.episode.public_stats,
              likes_count: state.episode.public_stats.likes_count + 1
            }
          }
        };
      }
    case 'UPDATE_POPCOMMENTS_COUNTER':
      return {
        ...state,
        episode: {
          ...state.episode,
          public_stats: {
            ...state.episode.public_stats,
            pop_comments_count: state.episode.public_stats.pop_comments_count + (action.payload === 'decrement' ? -1 : 1)
          }
        }
      };
    case 'SET_COMMENTS_COUNT':
      return {
        ...state,
        episode: {
          ...state.episode,
          public_stats: {
            ...state.episode.public_stats,
            comments_count: action.comments_count
          }
        }
      };
    default:
      return state;
  }
};

export { initialState, reducer };
export default reducer;
